import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { Coupon, CreateCouponInput, UpdateCouponInput } from '../types/coupon';
import CouponService from '../services/couponService';

export const useCoupons = () => {
  const queryClient = useQueryClient();

  const { data: coupons, isLoading, error } = useQuery({
    queryKey: ['coupons'],
    queryFn: () => CouponService.getAllCoupons(),
  });

  const createCoupon = useMutation({
    mutationFn: (payload: CreateCouponInput) => CouponService.createCoupon(payload),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['coupons'] }),
  });

  const updateCoupon = useMutation({
    mutationFn: ({ id, payload }: { id: string; payload: UpdateCouponInput }) =>
      CouponService.updateCoupon(id, payload),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['coupons'] }),
  });

  const deleteCoupon = useMutation({
    mutationFn: (id: string) => CouponService.deleteCoupon(id),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['coupons'] }),
  });

  return {
    coupons,
    isLoading,
    error,
    createCoupon,
    updateCoupon,
    deleteCoupon,
  };
};

export default useCoupons;


